import {classNames as $6e6392558d48dfec$export$ce4ab0c55987d1ff} from "../utils/classNames.mjs";
import "../button_vars.css";
import $cbPEp$button_vars_cssmjs from "../button_vars_css.mjs";
import {useFocusableRef as $3c2c983d5210446c$export$96a734597687c040} from "../utils/useDOMRef.mjs";
import {useStyleProps as $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41} from "../utils/styleProps.mjs";
import {useButton as $cbPEp$useButton} from "react-aria/useButton";
import $cbPEp$spectrumiconsuiCrossSmall from "@spectrum-icons/ui/CrossSmall";
import {FocusRing as $cbPEp$FocusRing} from "react-aria/FocusRing";
import {mergeProps as $cbPEp$mergeProps} from "react-aria/mergeProps";
import $cbPEp$react from "react";
import {useHover as $cbPEp$useHover} from "react-aria/useHover";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 









const $ab14010a528467be$export$13ec83e50bf04290 = /*#__PURE__*/ (0, $cbPEp$react).forwardRef(function ClearButton(props, ref) {
    let { children: children = /*#__PURE__*/ (0, $cbPEp$react).createElement((0, $cbPEp$spectrumiconsuiCrossSmall), {
        UNSAFE_className: (0, ($parcel$interopDefault($cbPEp$button_vars_cssmjs)))['spectrum-Icon']
    }), focusClassName: focusClassName, variant: variant, autoFocus: autoFocus, isDisabled: isDisabled, preventFocus: preventFocus, elementType: elementType = preventFocus ? 'div' : 'button', inset: inset = false, ...otherProps } = props;
    let domRef = (0, $3c2c983d5210446c$export$96a734597687c040)(ref);
    let { buttonProps: buttonProps, isPressed: isPressed } = (0, $cbPEp$useButton)({
        ...props,
        elementType: elementType
    }, domRef);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $cbPEp$useHover)({
        isDisabled: isDisabled
    });
    let { styleProps: styleProps } = (0, $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41)(otherProps);
    // For cases like the clear button in a search field, remove the tabIndex so
    // iOS 14 with VoiceOver doesn't focus the button and hide the keyboard when
    // moving the cursor over the clear button.
    if (preventFocus) delete buttonProps.tabIndex;
    let ElementType = elementType;
    return /*#__PURE__*/ (0, $cbPEp$react).createElement((0, $cbPEp$FocusRing), {
        focusRingClass: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($cbPEp$button_vars_cssmjs))), 'focus-ring', focusClassName),
        autoFocus: autoFocus
    }, /*#__PURE__*/ (0, $cbPEp$react).createElement(ElementType, {
        ...styleProps,
        ...(0, $cbPEp$mergeProps)(buttonProps, hoverProps),
        ref: domRef,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($cbPEp$button_vars_cssmjs))), 'spectrum-ClearButton', {
            [`spectrum-ClearButton--${variant}`]: variant,
            'is-disabled': isDisabled,
            'is-active': isPressed,
            'is-hovered': isHovered,
            'spectrum-ClearButton--inset': inset
        }, styleProps.className)
    }, children));
});


export {$ab14010a528467be$export$13ec83e50bf04290 as ClearButton};
//# sourceMappingURL=ClearButton.mjs.map
